import React, { PropTypes } from 'react';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import cn from 'classnames';

import './BatchActionButton.scss';

export default function BatchActionButton({ className, handleClick, selectedItemCount, children }) {
  return (
    <PrimaryButton
      className={cn('cp-batch-action-button', className)}
      handleClick={handleClick}
      disabled={selectedItemCount === 0}>
      {children}
      {selectedItemCount > 0 ? ` (${selectedItemCount})` : ''}
    </PrimaryButton>
  );
}

BatchActionButton.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  selectedItemCount: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};




// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionButton/BatchActionButton.jsx